export enum JxtLocationTypeEnum {
  BUILDING = 'BUILDING',
  SITE = 'SITE',
}
